import { render, staticRenderFns } from "./Component_PagingBar.vue?vue&type=template&id=3141f8c7&scoped=true&"
import script from "./Component_PagingBar.vue?vue&type=script&lang=js&"
export * from "./Component_PagingBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141f8c7",
  null
  
)

export default component.exports